import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Contact from './components/Contact';
import AvAligner from './components/AvAligner';

function App() {
  const normalizedPath =
    window.location.pathname.replace(/\/+$/, '') || '/';
  const isAvAlignerRoute = normalizedPath === '/av-aligner';

  if (isAvAlignerRoute) {
    return <AvAligner />;
  }

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Experience />
      <Contact />
    </div>
  );
}

export default App;
